import Navbar from '../components/layout/Navbar';
import StockTicker from '../components/layout/StockTicker';
import Footer from '../components/layout/Footer';
import { Link } from 'react-router-dom';
import brand from '../config/brand';

export default function TermsOfUsePage() {
  return (
    <div className="min-h-screen bg-[#020617]" data-testid="terms-of-use-page">
      <StockTicker />
      <Navbar />

      {/* Header */}
      <header className="py-12 border-b border-[#1E293B]">
        <div className="max-w-4xl mx-auto px-4">
          <h1
            className="text-4xl md:text-5xl font-bold text-slate-50"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            Terms of Use
          </h1>
          <p className="text-slate-500 mt-2">Last updated: January 2026</p>
        </div>
      </header>

      {/* Content */}
      <section className="py-12">
        <div className="max-w-4xl mx-auto px-4">
          <div className="prose prose-invert prose-lg max-w-none space-y-8">
            
            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                1. Acceptance of Terms
              </h2>
              <p className="text-slate-400 leading-relaxed">
                Greetings, valued customer ("You"). Welcome to {brand.name}. Your use of our service is subject to these Terms of Service ("TOS"), which may be periodically updated by {brand.name} with prior notice through email. By logging into our system, you signify your agreement to these terms.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                2. Description of Products & Service
              </h2>
              <p className="text-slate-400 leading-relaxed">
                {brand.name} provides information and news in the following categories: Financial news, economy news, financial trends, fintech, investment news, personal finance guidance, debt management resources, and market analysis.
              </p>
              <div className="bg-[#D4AF37]/5 border border-[#D4AF37]/20 rounded-none p-4 mt-4">
                <p className="text-slate-200 font-bold leading-relaxed">
                  CONTENT ATTRIBUTION NOTICE: Some of the content displayed on this website is aggregated from third-party sources, including The Guardian and Google News. All articles, images, and other media content remain the intellectual property of their respective owners and original publishers. {brand.name} does not claim ownership of any third-party content. All rights, including copyrights and trademarks, belong to the actual owners of such rights. This content is provided for informational purposes only.
                </p>
              </div>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                3. {brand.name} Privacy Policy
              </h2>
              <p className="text-slate-400 leading-relaxed">
                To set up your account, specific information is required. Your information will not be released without prior consent, unless mandated by law. {brand.name} collects phone numbers of prospective members accessing information via SMS, and these numbers will not be shared.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                4. Mobile Terms & Conditions
              </h2>
              <p className="text-slate-400 leading-relaxed">
                By providing your consent and subscribing, you consent to receiving recurring informational SMS or MMS messages from {brand.name}. This program will deliver notifications on financial news, economy updates, financial trends, fintech, and investment news. The subscription service is at the standard rate and is accessible on various carriers. Message and data rates may apply. Carriers are not responsible for delayed or undelivered messages. Message frequency may vary.
              </p>
              <p className="text-slate-400 leading-relaxed">
                To end your subscription, text STOP, END, QUIT, CANCEL, or UNSUBSCRIBE. For support, text HELP or email{' '}
                <a href={`mailto:${brand.supportEmail}`} className="text-[#D4AF37] hover:underline">
                  {brand.supportEmail}
                </a>
                . The service will continue until canceled by the customer.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                5. Member Conduct
              </h2>
              <p className="text-slate-400 leading-relaxed">
                You agree that {brand.name} may access, preserve, and disclose account information and content when required by law or in good faith belief. You understand that technical processing may involve network transmissions and adaptation to technical requirements. Service use is subject to usage rules set by {brand.name}, and unauthorized reproduction or distribution is prohibited.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                6. Indemnity
              </h2>
              <p className="text-slate-400 leading-relaxed">
                You commit to defending, indemnifying, and holding {brand.name}, its officers, agents, and employees harmless from claims arising from your subscription or use of {brand.name} services.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                7. No Resale of Service
              </h2>
              <p className="text-slate-400 leading-relaxed">
                The {brand.name} service is non-transferable, and you may not exploit it for commercial purposes.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                8. Modifications to Service
              </h2>
              <p className="text-slate-400 leading-relaxed">
                {brand.name} reserves the right to modify or discontinue the Service at any time without notice.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                9. Termination
              </h2>
              <p className="text-slate-400 leading-relaxed">
                {brand.name} may terminate your account and Service access under certain circumstances without prior notice. Termination includes deletion of your account's information.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                10. {brand.name} Proprietary Rights
              </h2>
              <p className="text-slate-400 leading-relaxed">
                The Service and Software used in connection with it are protected by intellectual property laws. Modification, distribution, or derivative works creation is prohibited.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                11. Disclaimer of Warranties
              </h2>
              <p className="text-slate-400 leading-relaxed">
                The Service is provided "AS-IS." {brand.name} disclaims all warranties, and usage is at your own risk.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                12. Limitation of Liability
              </h2>
              <p className="text-slate-400 leading-relaxed">
                {brand.name} is not liable for direct or indirect damages arising from your use of the Service.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                13. Exclusions and Limitations
              </h2>
              <p className="text-slate-400 leading-relaxed">
                Some jurisdictions may not allow certain limitations of warranties or liability exclusions.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                14. Notice
              </h2>
              <p className="text-slate-400 leading-relaxed">
                Notices from {brand.name} will be provided via email, regular mail, or postings on the Service.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                15. Trademark Information
              </h2>
              <p className="text-slate-400 leading-relaxed">
                You may use {brand.name} marks for marketing campaigns with permission.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                16. General Information
              </h2>
              <p className="text-slate-400 leading-relaxed">
                The TOS constitute the entire agreement between you and {brand.name}, governing your use of the Service.
              </p>
            </div>

            <div className="space-y-4">
              <h2 className="text-2xl font-bold text-slate-100" style={{ fontFamily: "'Cormorant Garamond', serif" }}>
                17. Violations
              </h2>
              <p className="text-slate-400 leading-relaxed">
                Please report any TOS violations to{' '}
                <a href={`mailto:${brand.legalEmail}`} className="text-[#D4AF37] hover:underline">
                  {brand.legalEmail}
                </a>
              </p>
            </div>

          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
